import SurveySecondaryBar from './SurveySecondaryBar.vue'

export default SurveySecondaryBar